import { useSelector } from 'react-redux';
import { AppState } from '../../../Configs/Redux/AppState';
import * as React from 'react';
import { getToken } from '../Token/GetToken';

const PrivateComponent: React.FunctionComponent = ({ children }) => {
  const { user } = useSelector((state: AppState) => state.App);
  const token = getToken();

  const isAuthenticated = token && !!user.id;

  return isAuthenticated ? <>{children}</> : null;
};

export default PrivateComponent;
